<template>
  <unicon :name="plusOrMinus" fill="currentColor"></unicon>
</template>

<script>
export default {
  props: {
    sign: {
      type: String,
      required: false,
      default: 'plus'
    }
  },
  computed: {
    plusOrMinus() {
      return this.sign === 'plus' ? 'plus' : 'minus'
    }
  }
}
</script>

<style lang="postcss" scoped>
.unicon {
  @apply inline;
}
</style>
